export default __webpack_public_path__ + "static/media/alert_icon_incorrect.7710600a.svg";